module.exports = __webpack_public_path__ + "static/furniture-live-help-section-code-bc2339984821842095d4ec08e61e61db.png";